// moduleShape.js — tells the two module formats apart.
//
// Legacy modules keep everything under `content` and each micro-session is a
// bag of hand-named keys rendered by a 6,000-line shape cascade. Block
// modules put `microSessions` at the top level and each session carries a
// `blocks` array rendered by the block kit. The viewer switches on this.
export const isBlockModule = (module) =>
  Array.isArray(module?.microSessions) &&
  module.microSessions.some((s) => Array.isArray(s?.blocks));

// Micro-sessions regardless of format — used where both shapes are in play
// (module cards, derived duration and XP).
export const getMicroSessions = (module) => {
  if (Array.isArray(module?.microSessions)) return module.microSessions;
  return module?.content?.microSessions || [];
};

// Minutes for a session in either format: `estimatedMinutes: 6` or
// `duration: '6 minutes'`.
export const sessionMinutes = (session) => {
  if (!session) return 0;
  if (typeof session.estimatedMinutes === 'number') return session.estimatedMinutes;
  return parseInt(session.duration, 10) || 0;
};
